import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { FUTURE_TOKENS } from '../../constants/futureTokens.js';
import { spacing4x, spacing1x, spacing3x } from '../../styles/spacing.js';
import { ButtonMenu } from '../ButtonMenu/ButtonMenu.js';
import { CardBase } from '../CardBase/CardBase.js';
import { CardDescription } from '../CardBase/CardDescription.js';
import { CardTitle } from '../CardBase/CardTitle.js';
import { IconMore } from '../Icons/IconMore.js';
import { statusComponents, Status } from '../Status/Status.js';
import { ContentCardCheckbox } from './ContentCardCheckbox/ContentCardCheckbox.js';
import { HeaderOverlayMask, ContentCardExhibit } from './ContentCardExhibit/ContentCardExhibit.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["actions", "buttonMenuProps", "checkboxProps", "descriptionProps", "exhibit", "src", "statusProps", "titleProps"];
var ContentCardActions = styled.div.withConfig({
  displayName: "ContentCard__ContentCardActions",
  componentId: "sc-1ohx6rk-0"
})(["&&{display:flex;opacity:0;align-items:center;justify-content:center;}&& > div{align-items:center;display:flex;justify-content:center;min-height:32px;min-width:32px;}"]);
var ContentCardCardBase = styled(CardBase).withConfig({
  displayName: "ContentCard__ContentCardCardBase",
  componentId: "sc-1ohx6rk-1"
})(["&&{", ";", ";", ";}&& :hover ", ",&& :focus-within ", "{opacity:1;}&& :hover ", ",&& :focus-within ", "{box-shadow:none;}&& :hover ", ",&& :focus-within ", "{opacity:0;}&& :hover ", ",&& :focus-within ", "{opacity:1;}"], function (props) {
  return props.expired && "\n        ".concat(HeaderOverlayMask, " {\n            background-color: ").concat(FUTURE_TOKENS.CONTENT_CARD_BASE_OVERLAY_BACKGROUND_COLOR, ";\n            opacity: 1;\n        }\n    ");
}, function (props) {
  return props.selected && "\n        ".concat(ContentCardCheckbox, " {\n            opacity: 1;\n        }\n    ");
}, function (props) {
  return props.selectable && !props.selected && "\n        :hover,\n        :focus-within {\n            ".concat(ContentCardCheckbox, " {\n                opacity: 1;\n            }\n        }\n    ");
}, HeaderOverlayMask, HeaderOverlayMask, ContentCardCheckbox, ContentCardCheckbox, statusComponents.StatusWrapper, statusComponents.StatusWrapper, ContentCardActions, ContentCardActions);
var ActionsContainer = styled.div.withConfig({
  displayName: "ContentCard__ActionsContainer",
  componentId: "sc-1ohx6rk-2"
})(["&&{display:flex;justify-content:flex-end;}"]);
var ContentCard = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var actions = props.actions,
    buttonMenuProps = props.buttonMenuProps,
    checkboxProps = props.checkboxProps,
    descriptionProps = props.descriptionProps,
    exhibit = props.exhibit,
    src = props.src,
    statusProps = props.statusProps,
    titleProps = props.titleProps,
    rest = _objectWithoutProperties(props, _excluded);
  var expired = (statusProps === null || statusProps === void 0 ? void 0 : statusProps.variant) === "expired";
  var selectable = !!checkboxProps;
  return /*#__PURE__*/jsx(ContentCardCardBase, _objectSpread(_objectSpread({}, rest), {}, {
    areas: ["a b c d", "e f g h", "i j k l", "m n o p"],
    columns: ["36px", "1fr", "1fr", "52px"],
    rows: ["120px", "auto", "1fr", "48px"],
    items: [{
      area: ["a", "a", "a", "d"],
      children: /*#__PURE__*/jsx(ContentCardExhibit, {
        exhibit: exhibit,
        src: src
      })
    }, {
      area: "a",
      align: "start",
      justify: "start",
      style: selectable ? {
        lineHeight: 0,
        paddingInlineStart: spacing4x,
        paddingTop: spacing4x
      } : {},
      children: selectable ? /*#__PURE__*/jsx(ContentCardCheckbox, _objectSpread({}, checkboxProps)) : void 0
    }, {
      area: ["e", "e", "e", "h"],
      align: "start",
      justify: "start",
      style: {
        paddingInlineStart: spacing4x,
        paddingInlineEnd: spacing4x,
        paddingTop: spacing4x
      },
      children: /*#__PURE__*/jsx(CardTitle, _objectSpread(_objectSpread({
        maxLength: 50
      }, titleProps), {}, {
        style: {
          WebkitLineClamp: 2
        }
      }))
    }, {
      area: ["i", "i", "i", "l"],
      align: "start",
      justify: "start",
      style: {
        paddingInlineStart: spacing4x,
        paddingInlineEnd: spacing4x,
        paddingTop: spacing1x
      },
      children: /*#__PURE__*/jsx(CardDescription, _objectSpread({}, descriptionProps))
    }, {
      area: ["m", "m", "m", "o"],
      align: "end",
      justify: "start",
      style: {
        paddingBottom: spacing4x,
        paddingInlineStart: spacing4x
      },
      children: statusProps && /*#__PURE__*/jsx(Status, _objectSpread({}, statusProps))
    }, {
      area: ["m", "m", "m", "p"],
      align: "end",
      justify: "end",
      style: {
        paddingBottom: 10,
        paddingInlineEnd: spacing3x
      },
      children: /*#__PURE__*/jsxs(ActionsContainer, {
        children: [/*#__PURE__*/jsx(ContentCardActions, {
          children: React.Children.map(actions, function (child) {
            return /*#__PURE__*/jsx("div", {
              children: child
            });
          })
        }), buttonMenuProps && /*#__PURE__*/jsx(ButtonMenu, _objectSpread(_objectSpread({}, buttonMenuProps), {}, {
          buttonProps: _objectSpread({
            hideLabel: true,
            startAdornment: IconMore,
            variant: "ghost"
          }, buttonMenuProps.buttonProps)
        }))]
      })
    }],
    expired: expired,
    ref: ref,
    selectable: selectable,
    selected: checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.checked,
    style: {
      height: descriptionProps.children ? 270 : 226,
      minWidth: 216,
      width: 216
    }
  }));
});
ContentCard.displayName = "ContentCard";

export { ContentCard };
